import { createPortal } from 'react-dom';

import { useVisibleToasts } from './toastStore';
import { Toast } from './Toast';

/**
 * Globální host pro toast notifikace.
 * Zobrazuje maximálně 3 viditelné toasty, přičemž další čekají ve frontě.
 *
 * Portál do `document.body` + vysoký z-index: toasty musí být NAD okny frameworku
 * (PhoenixDesktop, z-index `10 + stackZ*100`, neomezeně roste — proto by je nízký z-index
 * schoval za samostatná okna). Zůstávají POD popup menu (DropdownMenu/MenuPopover/MenuSearch =
 * `99999999`, backdrop `99999998`) — jediné, co smí být výš.
 *
 * Built on: Custom composition over shadcn building blocks
 */
export function ToastHost() {
  const visibleToasts = useVisibleToasts();

  if (visibleToasts.length === 0) {
    return null;
  }

  return createPortal(
    <div
      className="fixed right-0 bottom-0 z-[99999990] flex max-h-screen w-full flex-col gap-2 p-4 sm:max-w-[420px]"
      aria-label="Notifications"
    >
      {visibleToasts.map((item) => (
        <Toast key={item.id} item={item} />
      ))}
    </div>,
    document.body
  );
}
